'use client';
import {
	getEventActionName,
	getSearchTermHistory,
} from '@/globals/analytics/events/pushSearchEvent';
import { SearchState } from '@/globals/dataCollector/searchDataCollector/types/searchParams.types';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { PropsWithChildren } from 'react';
import { useSearchHistory } from './useSearchHistory';
import { addTestSelector } from '@/globals/testHelpers/testSelector';

export const SearchResultLinkClient = ({
	searchState,
	href,
	children,
	total,
	className,
}: PropsWithChildren<{
	href: string;
	searchState: SearchState;
	total: number;
	className?: string;
}>) => {
	const facetName = getEventActionName(searchState);
	const searchHistory = useSearchHistory();

	const searchTermHistory = getSearchTermHistory(searchHistory);

	return (
		<DOPLink
			href={href}
			className={className}
			data-link-type="searchResult"
			data-facet={facetName}
			data-term={searchState.term}
			data-total={total}
			data-number-of-searches={searchTermHistory.length}
			data-refinement={searchTermHistory.join(' > ')}
			{...addTestSelector('uiSearchHit')}
		>
			{children}
		</DOPLink>
	);
};
